import script from "./DomainModelReadModelFields.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelReadModelFields.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelReadModelFields.vue?vue&type=style&index=0&id=2ea175f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea175f0"]])

export default __exports__